import { useTranslation } from 'react-i18next';
import { Typography } from 'mobily-ui-library/lib';

import Brand from '../../../assets/Brand.svg';
import CircleArrow from '../../../assets/CircleArrow.svg';

import './ProductFinance.scss';

interface Props {
    rtl: boolean;
    subsidyFlag: any;
    handleAddCart: (flow: string) => void;
    instalmentFlag: any;
}

function ProductFinance({ rtl, subsidyFlag, handleAddCart, instalmentFlag }: Props) {
    const { t } = useTranslation();
    const isSubsidy: any = subsidyFlag ? "Yes" : "No";
    const isInstalment: any = instalmentFlag ? "Yes" : "No";

    const handleCheck = (flow: any) => {
        handleAddCart(flow);
        const wcmElement: any = document.getElementById("reactWCMControlBlockID");
        if (wcmElement !== null) {
            wcmElement.style.display = 'none';
        }
    }

    return (
    <div id='device-finances' className='deviceDetails__financesContainer'>
        <Typography rtl={rtl} className='DD__FinanceTitle'>{t('Mobily_Financing')}</Typography>

        {isSubsidy === "Yes" ? (
            <div className='deviceDetails__Subsidy'>
                <div className='DD__SubsidyHead'>
                    <img src={Brand} alt='mobily-icon' />
                    <Typography rtl={rtl} className='DD__SubsidyTitle'>{t('Device_subsidy')}</Typography>
                </div>
                <Typography rtl={rtl} className='DD__SubsidyContent'>{t('Get_Discount_Upto')} 7200 {t('SAR')}.</Typography>
                <Typography rtl={rtl} className='DD__SubsidyContent'>{t('For_selected_plan')}<sup>3</sup></Typography>

                <Typography rtl={rtl} className='DD__SubsidyLink' onClick={() => { handleCheck('subsidy') }}>
                    {t('Check_Discount')} <img src={CircleArrow} alt='arrow' />
                </Typography>
            </div>) : (<></>)}

        {isInstalment === "Yes" ? (
            <div className='deviceDetails__Installments'>
                <div className='DD__SubsidyHead'>
                    <img src={Brand} alt='mobily-icon' />
                    <Typography rtl={rtl} className='DD__SubsidyTitle'>{t('device_installments')}</Typography>
                </div>
                <Typography rtl={rtl} className='DD__SubsidyContent'>{t('split_the_cost_instalments', { upto_amount: 'X' })}</Typography>
                <Typography rtl={rtl} className='DD__SubsidyContent'>{t('For_selected_plan')}<sup>4</sup></Typography>

                <Typography rtl={rtl} className='DD__SubsidyLink' onClick={() => { handleCheck('instalment') }}>
                    {t('Check_Eligibility')} <img src={CircleArrow} alt='arrow' />
                </Typography>
            </div>) : (<></>)}
    </div>

    )
}

export default ProductFinance